import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    text-align: center;\n    display: flex;\n    \n    ", " \n    ", " \n    ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    text-decoration: none;\n    &:hover,\n    &:visited,\n    &:active,\n    &:focus {\n        text-decoration: none;\n    }\n\n    ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    min-width: 100px;\n\n    &::after {\n        content: '';\n        height: 3px;\n        position: absolute;\n        transform: scaleX(0);\n        transition: transform ", "s ease-out;\n        width: auto;\n\n        ", "\n        ", "\n    }\n\n    ", "\n    ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n            cursor: default;\n        "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n            pointer-events: none;\n        "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n              cursor: not-allowed;\n          "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            justify-content: center;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        padding: ", " ", ";\n        color: ", ";\n        border-radius: ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            flex-grow: 1;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            transform: scaleX(1);\n            transition: all ", "s ease;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { marginAttributes } from '../../system/attributes';
import { mouseCursor } from '../../styling';
import { transitionDurationInSec } from '../../constants';
import { borderRadius, color, spacing } from '../../system/mixins';
import { getPropsBlocker, makePropList } from '../../utils';
import { Typography } from '../Typography';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
var propertyList = makePropList(['isActive']);

var animationStyle = function animationStyle(_ref) {
  var isActive = _ref.isActive,
      Tab = _ref.theme.componentOverrides.Tab;
  return isActive ? Tab.Root.active__after : 'position: relative;';
};

var tabRootStyle = function tabRootStyle(_ref2) {
  var isActive = _ref2.isActive,
      wide = _ref2.wide;
  var result = css(_templateObject());

  if (isActive) {
    result = css(_templateObject2(), result, transitionDurationInSec);
  }

  if (wide) {
    result = css(_templateObject3(), result);
  }

  return result;
};

var tabRootAfterStyle = function tabRootAfterStyle(_ref3) {
  var Tab = _ref3.theme.componentOverrides.Tab;
  return Tab.Root.after;
};

var tabLabelStyle = function tabLabelStyle(_ref4) {
  var disabled = _ref4.disabled,
      isActive = _ref4.isActive,
      Tab = _ref4.theme.componentOverrides.Tab,
      wide = _ref4.wide;
  var result = css(_templateObject4(), spacing(1), spacing(6), color('neutral.05'), borderRadius('sharp'));

  if (wide) {
    result = css(_templateObject5(), result);
  }

  if (disabled) {
    return css(_templateObject6(), result, Tab.Label.disabled);
  }

  if (isActive) {
    return css(_templateObject7(), result, Tab.Label.active);
  }

  if (!isActive) {
    return css(_templateObject8(), result, Tab.Label.hover);
  }

  return result;
};

var tabLabelContainerStyle = function tabLabelContainerStyle(_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? css(_templateObject9()) : '';
};

var cursor = function cursor(_ref6) {
  var disabled = _ref6.disabled,
      isActive = _ref6.isActive;

  if (disabled) {
    return css(_templateObject10());
  }

  if (isActive) {
    return css(_templateObject11());
  }

  return mouseCursor;
};

export var TabRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject12(), transitionDurationInSec, tabRootAfterStyle, animationStyle, tabRootStyle, getComponentOverride('Tab'));

var TabLabelTagWrapper = function TabLabelTagWrapper(_ref7) {
  var children = _ref7.children,
      restProps = _objectWithoutProperties(_ref7, ["children"]);

  return children(restProps);
};

export var TabLabelContainer = styled(TabLabelTagWrapper).withConfig(getPropsBlocker(propertyList, false))(_templateObject13(), tabLabelContainerStyle);
export var TabLabel = styled(Typography).withConfig(getPropsBlocker(propertyList, false))(_templateObject14(), tabLabelStyle, marginAttributes, cursor);